// Real, permission-cleared learner quotes only. Static entries are merged with admin-approved
// submissions from GET /api/testimonials/public (collected in-app via ShareStory after a finished lesson).
// Shape: { quote: "One or two sentences.", name: "First name", role: "retired Army, Killeen TX", photo: "/img/learners/first.jpg" (optional) }
export const TESTIMONIALS = [];

export const STORY_ROLES = ["Veteran", "Family member", "Caregiver", "Peer-support staff", "Chaplain", "Provider", "Educator", "Other"];

// Dated external mentions only (a partner announcement, a newsletter feature, a review profile).
// Shape: { date: "Month YYYY", outlet: "Outlet name", title: "Headline or context", url: "https://..." }
export const PRESS = [];

// The signed-up-learners counter is shown once this many learners exist.
export const LEARNER_COUNT_MIN = 10;

export const FACTS = [
  { n: "20", s: "sequenced lessons" },
  { n: "5", s: "modules" },
  { n: "10", s: "stages in the Investigation Method™" },
  { n: "Dec 2025", s: "founded in Texas" },
];
